import supportsTimeZoneFormat from './supportsTimeZoneFormat';

export default function getTimeZoneFormat(timeZone) {
  if (timeZone == null || !supportsTimeZoneFormat()) {
    return undefined;
  }
  return timeZone;
}
